export enum Role {
  SUPER_ADMIN = "super_admin",
  COMPANY_ADMIN = "company_admin",
  OWL_WAREHOUSE = "owl_warehouse",
  YAMAS_GATEMANAGER = "yamas_gateManager",
  YAMAS_WAREHOUSEMANAGER = "yamas_warehouseManager",
}
